// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"a8b6d5f3aa7c6c15","6831":"9483828bad89295f","8503":"5cf9ecaed1797df0","9683":"afb600361218a92c"}[chunkId] + ".js";
};